import React from "react";
import ReactApexChart from "react-apexcharts";
import { formatCurrency } from "utility/index";

class ApexChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          name: props.title[0],
          data: props?.data?.map(data => data.totalPlannedBudget)
        },
        {
          name: props.title[1],
          data: props?.data?.map(data => data.totalSpentBudget)
        }
      ],
      options: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: false,
          toolbar: {
            show: false 
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '60%',
            endingShape: 'rounded'
          }
        },
        colors: ["#9DE1D1", "#DBB668"],
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (value) => `${props?.selectedCountry} ${formatCurrency(value,props?.selectedCountry).toLocaleString()}`
          }
        },
        xaxis: {
          labels: {
            style: {
              colors: '#fff',
              fontSize: '12px',
              fontWeight: 'medium',
            }
          },
          categories: props?.data?.map(data => data?.year?.toString()),
          axisBorder: {
            show: true,
            color: '#fff',
          },
          axisTicks: {
            show: true,
            color: '#fff',
            height: 7,
          },
        },
        yaxis: {
          min: 0,
          max: Math.max(...[...props?.data?.map(data => data.totalPlannedBudget),...props?.data?.map(data => data.totalSpentBudget)]),
          tickAmount: 4,
          labels: {
            style: {
              colors: '#fff',
              fontSize: '12px',
              fontWeight: 'medium',
            }
          },
          axisBorder: {
            show: true,
            color: '#fff',
            width: 1,
          },
          axisTicks: {
            show: true,
            color: '#fff',
            width: 7,
          },
          title: {
            text: "Budget",
            style: {
              color: '#FFFFFFBF', 
              fontSize: '18px',
              fontWeight: 'medium',
            }
          }
        },
        grid: {
          show: false,
        },
        legend: {
          show: false
        },
        stroke: {
          colors: ["transparent"],
          width: 5
        },
        responsive: [
          {
            breakpoint: 992,
            options: {
              stroke: {
                width: 2
              },
            },
          },
          {
            breakpoint: 576,
            options: {
              chart: {
                height: 250
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '80%',
                  endingShape: 'rounded'
                }
              },
              stroke: {
                width: 1
              },
              xaxis: {
                labels: {
                  style: {
                    colors: '#fff',
                    fontSize: '10px',
                    fontWeight: 'medium',
                  }
                },
                axisBorder: {
                  show: true,
                  color: '#fff',
                },
                axisTicks: {
                  show: true,
                  color: '#fff',
                  height: 7,
                },
              },
              yaxis: {
                min: 0,
                max: 10000,
                tickAmount: 4,
                labels: {
                  style: {
                    colors: '#fff',
                    fontSize: '10px',
                    fontWeight: 'medium',
                  }
                },
                axisBorder: {
                  show: true,
                  color: '#fff',
                  width: 1,
                },
                axisTicks: {
                  show: true,
                  color: '#fff',
                  width: 7,
                },
                title: {
                  text: "Budget",
                  style: {
                    color: '#FFFFFFBF', 
                    fontSize: '12px',
                    fontWeight: 'medium',
                  }
                }
              },
            },
          },
        ]
      },
    };
  }


  componentDidUpdate(prevProps) {
    // Check if props.data has changed
    if (prevProps.data !== this.props.data) {
      const newMax =Math.max(...[...this.props?.data?.map(data => data.totalPlannedBudget),...this.props?.data?.map(data => data.totalSpentBudget)]); // Calculate new max for y-axis
      this.setState({
        series: [
          {
            name: "Planned Budget",
            data: this?.props?.data?.map(data => data.totalPlannedBudget)
          },
          {
            name: "Spent Budget",
            data: this?.props?.data?.map(data => data.totalSpentBudget)
          }
        ],
        options: {
          ...this.state.options,
          tooltip: {
            enabled: true,
            y: {
              formatter: (value) => `${this?.props?.selectedCountry} ${formatCurrency(value,this?.props?.selectedCountry).toLocaleString()}`
            }
          },
          yaxis: {
            ...this.state.options.yaxis,
            max: newMax // Update max value dynamically
          },
          xaxis: {
            ...this.state.options.xaxis,
            categories: this.props?.data?.map(data => data?.year?.toString()) // Update categories
          },
        }
      });
    }
  }

  render() {
    console.log(this.props.data);
    return (
      <div>
        <div id="chart">
          <ReactApexChart options={{...this.state.options,xaxis:{...this.state.options.xaxis,categories: this.props?.data?.map(data => data?.year?.toString())}}} series={this.state.series} type="bar" height={380} />
        </div>
      </div>
    );
  }
}

export default ApexChart;